import { fiatCurrencies } from '@/constants/fiatCurrency'
import { solanaRpcEndpoints } from '@/constants/solana'
import {
  apiEndpoint,
  datasourceApiEndpoint,
  proxyApiEndpoint,
  splTokenApiEndpoint,
} from '@/environment'
import type { RunToDatabase } from '@/types'
import { atom } from 'jotai'
import { analyzeAccountList } from '../usecases/analyzeAccountList'
import { updateIsRequiredCalculationAtom } from './calculate'

export const analyzeAccountListAtom = atom(
  undefined,
  async (
    _,
    set,
    parameters: {
      readFromDatabase: RunToDatabase
      writeToDatabase: RunToDatabase
      getToken: () => Promise<string | null>
      readonly targetAccountIdList: readonly number[] | undefined
      onError: (error: unknown) => void
    },
  ) => {
    await analyzeAccountList({
      ...parameters,
      fiatCurrencyList: fiatCurrencies,
      apiEndpoint,
      datasourceApiEndpoint,
      proxyApiEndpoint,
      splTokenApiEndpoint,
      solanaRpcEndpoints,
      set,
    })
    await set(updateIsRequiredCalculationAtom, parameters)
  },
)
